import { Injectable } from '@angular/core';
import { AngularFirestoreDocument, AngularFirestore } from '@angular/fire/firestore';
import * as firebase from 'firebase';
import { map } from 'rxjs/operators';
import { Folder } from '../models/folder.model';

@Injectable({
  providedIn: 'root'
})
export class FolderService {

  database = 'Folders';
  databaseTrash = 'FoldersTrash';
  roomEscapeDoc: AngularFirestoreDocument<Folder>;
  constructor(
    private afs: AngularFirestore) { }


  get timestamp() {
    return firebase.firestore.FieldValue.serverTimestamp();
  } get ref() {
    return firebase.firestore().collection(this.database);
  }

  create(folder: Folder) {
    folder.i = this.afs.createId();
    const id = folder.i;
    const data = {};
    data[folder.i] = Object.assign({}, folder);
    return this.ref.firestore.doc(this.database + '/Folders').set(data, {merge: true});
  }
  edit(folder: Folder) {
    const data = {};
    data[folder.i] = Object.assign({}, folder);
    return this.ref.firestore.doc(this.database + '/Folders').set(data, { merge: true });
  }
  remove(folder: Folder) {
    const data = {};
    data[folder.i] = Object.assign({}, folder);
    this.ref.firestore.doc(this.databaseTrash + '/Folders').set(data, { merge: true});
    data[folder.i] = firebase.firestore.FieldValue.delete();
    return this.ref.firestore.doc(this.database + '/Folders').update(data);
  }
//   editVisible (folder: Folder, visible: boolean) {
//     const data = {};
//     folder.v = visible;
//     data[folder.i] = Object.assign({}, folder);
//     this.ref.firestore.doc(this.database + '/Folders').set(data, { merge: true});
//   }
  getAll() {
    return this.afs.doc<Folder>(this.database + '/Folders').snapshotChanges().pipe(
        map(action => {
            if (action.payload.data()) {
                const folders = [];
                Object.keys(action.payload.data()).map(key => {
                    folders.push(action.payload.data()[key]);
                });
                return folders;
            }
            return [];
        })
    );
  }
}
